<template>
  <Transition name="spoiler">
    <slot></slot>
  </Transition>
</template>

<style scoped lang="scss">
.spoiler {
  &-enter-active,
  &-leave-active {
    transition: var(--app-transition-md);
  }

  &-enter-from,
  &-leave-to {
    max-height: 0;
    opacity: 0;
  }
}
</style>
